export const padZero = (n) => String(n).padStart(2, 0);

export const time2seconds = (time) => {
  if (time) {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return seconds + minutes * 60 + hours * 60 * 60;
  }
};

const seconds2time = (seconds) => {
  const hours = padZero(Math.floor(seconds / (60 * 60)));
  const minutes = padZero(Math.floor(seconds / 60) % 60);
  seconds = padZero(seconds % 60);

  return `${hours}:${minutes}:${seconds}`;
};

export const toDuration = ({ startTime, endTime }) =>
  seconds2time(time2seconds(endTime) - time2seconds(startTime));

export const createBlobFile = (data, type, filename) => {
  const url = window.URL.createObjectURL(new Blob([data], { type: type }));
  const link = document.createElement("a");
  const typeExplode = type.split("/")[1];
  link.href = url;
  link.setAttribute("download", `${filename}.${typeExplode}`);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const removeDuplicates = (array, key) => {
  return array.reduce((arr, item) => {
    const removed = arr.filter((i) => i[key] !== item[key]);
    return [...removed, item];
  }, []);
};

export const removeSpaces = (str) => str.replace(/ /g, "");

export const getTime = (date) => {
  return new Date(date).toLocaleTimeString("EN", {
    hour12: false,
  });
};

export const hasAttribute = (obj, key) => {
  return key in obj;
};

export const GMTToLocalStringTime = (GMTTime = null) => {
  var date = GMTTime ? new Date(GMTTime) : new Date();
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
};
